import React from 'react';
import { List, ListItem, Link } from '@mui/material';
import { Card, Col, Row } from 'react-bootstrap';

const OtherReferenceList = () => {
  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Reference za ostalo
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <List>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-radio-button/"
                  target={'_blank'}
                >
                  Radio button
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-badge/"
                  target={'_blank'}
                >
                  Badge/Notification indicator
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-alert/"
                  target={'_blank'}
                >
                  Info box
                </Link>
              </ListItem>
            </List>
          </Col>
          <Col>
            <List>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-breadcrumbs/"
                  target={'_blank'}
                >
                  Breadcrumb
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-textarea-autosize/"
                  target={'_blank'}
                >
                  Textarea autosize
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-chip/"
                  target={'_blank'}
                >
                  Badges (Chip)
                </Link>
              </ListItem>
            </List>
          </Col>
          <Col>
            <List>
              <ListItem>
                <Link
                  href="https://mui.com/material-ui/react-drawer/"
                  target={'_blank'}
                >
                  Menu popup (Drawer)
                </Link>
              </ListItem>
            </List>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default OtherReferenceList;
